import React, { useState, useMemo } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { Select } from "components/common";
import NumberUtils from "util/NumberUtils";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const StyledForm = styled.form`
  margin-top: 10px;
  margin-bottom: 15px;

  .form-group {
    width: 400px;
  }
`;
const StyledP = styled.p`
  margin-top: 5px;
`;
const _getDefaultIndex = (indices) => {
  const defaultIndex = indices.filter(
    (index) => !index.index_name.endsWith("restored_archive") && index.document_count >= 1
  )[0];
  return defaultIndex == null ? void 0 : defaultIndex.index_name;
};
const ArchiveCreationForm = ({ indices: indicesProp, createArchive = () => {
} }) => {
  const indices = indicesProp || [];
  const storableIndices = indices.filter(({ index_name }) => !index_name.endsWith("restored_archive"));
  const [selectedIndexName, setSelectedIndexName] = useState(_getDefaultIndex(indices));
  const indicesOptions = useMemo(() => {
    if (storableIndices.length) {
      return storableIndices.map((index) => {
        const docs = index.document_count;
        const size = NumberUtils.formatBytes(index.store_size_bytes);
        return {
          value: index.index_name,
          label: `${index.index_name} (${NumberUtils.formatNumber(docs)} documents / ${size})`,
          disabled: docs < 1
        };
      });
    }
    return [{ value: "none", label: "No indices available", disabled: true }];
  }, [storableIndices]);
  const sendTelemetry = useSendTelemetry();
  const _onIndexSelect = (selection) => {
    if (selection === "") {
      setSelectedIndexName(_getDefaultIndex(indices));
    }
    setSelectedIndexName(selection);
  };
  const _onSubmit = (e) => {
    e.preventDefault();
    if (selectedIndexName) {
      createArchive(selectedIndexName);
    }
    sendTelemetry(TELEMETRY_EVENT_TYPE.ARCHIVE.CREATED, {
      app_pathname: "archive",
      app_section: "archive-catalog"
    });
  };
  const _isButtonDisabled = () => {
    var _a;
    return !selectedIndexName || ((_a = indices.find(({ index_name }) => index_name === selectedIndexName)) == null ? void 0 : _a.document_count) < 1;
  };
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h2", null, "Create Archive for Index"), /* @__PURE__ */ React.createElement(StyledP, null, "Select an index to be archived to disk. This action will not close or delete the original index."), /* @__PURE__ */ React.createElement(StyledForm, { className: "form-inline", onSubmit: _onSubmit }, /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement(
    Select,
    {
      "aria-label": "Select index for archiving",
      placeholder: "Select index",
      options: indicesOptions,
      onChange: _onIndexSelect,
      value: selectedIndexName
    }
  )), "\xA0", /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", type: "submit", disabled: _isButtonDisabled() }, "Archive index")));
};
export default ArchiveCreationForm;
